// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".xSetfVxmQLLc5JzdjGfe{margin-bottom:5px}", "",{"version":3,"sources":["webpack://./src/components/BranchSelectorLabel/BranchSelectorLabel.module.scss"],"names":[],"mappings":"AAAA,sBACE,iBAAA","sourcesContent":[".Label {\n  margin-bottom: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Label": "xSetfVxmQLLc5JzdjGfe"
};
export default ___CSS_LOADER_EXPORT___;
